import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import CreateTankInstallationPage from "./CreateTankInstallationForm";
import EditTankInstallationPage from "./EditTankInstallationForm";


export const TankInstallationModule = () => {
  let { path } = useRouteMatch();

  return (
    
      <Switch>
        <ProtectedRoute exact path={path}>
              <CreateTankInstallationPage />
        </ProtectedRoute> 
        <ProtectedRoute exact path={`${path}/:id(\\d+)`}>
              <EditTankInstallationPage />
        </ProtectedRoute>
       
      </Switch>
    
  );
};

export default TankInstallationModule;
